import { Navigate, Route } from "react-router-dom";
import { BookingsListPage } from "../features/bookings/pages/bookings.page";
import { CarrierDetailPage } from "../features/carriers/pages/carrier-detail.page";
import { CarriersListPage } from "../features/carriers/pages/carriers.page";
import { CustomerDetailPage } from "../features/customers/pages/customer-detail.page";
import { CustomersListPage } from "../features/customers/pages/customers.page";
import { OperatorDetailPage } from "../features/operators/pages/operator-detail.page";
import { OperatorsListPage } from "../features/operators/pages/operators.page";
import { DashboardPage } from "../features/dashboard/pages/dashboard.page";
import { SettingsBookingsPage } from "../features/settings/pages/settings-bookings.page";
import { SettingsUsersPage } from "../features/settings/pages/settings-users.page";
import { SettingsRolesPage } from "../features/settings/pages/settings-roles.page";

/**
 * Child routes for `<SignedInAppLayout />` — must be under one parent `<Routes>` in `app.tsx` with
 * `<Outlet />`. A second nested `<Routes>` here breaks `/customers` in React Router 7.
 */
export function operatorSignedInChildRoutes() {
  return [
    <Route key="index" index element={<DashboardPage />} />,
    <Route key="operators" path="operators" element={<OperatorsListPage />} />,
    <Route key="operator-detail" path="operators/:id" element={<OperatorDetailPage />} />,
    <Route key="customers" path="customers" element={<CustomersListPage />} />,
    <Route key="customer-detail" path="customers/:id" element={<CustomerDetailPage />} />,
    <Route key="bookings" path="bookings" element={<BookingsListPage />} />,
    <Route key="carriers" path="carriers" element={<CarriersListPage />} />,
    <Route key="carrier-detail" path="carriers/:id" element={<CarrierDetailPage />} />,
    <Route key="settings-users" path="settings/users" element={<SettingsUsersPage />} />,
    <Route key="settings-bookings" path="settings/bookings" element={<SettingsBookingsPage />} />,
    <Route key="settings-roles" path="settings/roles" element={<SettingsRolesPage />} />,
    <Route key="settings" path="settings" element={<Navigate to="/settings/users" replace />} />,
    <Route key="fallback" path="*" element={<Navigate to="/" replace />} />,
  ];
}
